module.exports = __webpack_public_path__ + "img/logo-highlight.7c77b629.png";